"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var oneDay = moment_1.default.duration('1', 'day');
var oneHour = moment_1.default.duration('1', 'hour');
function humanizeTimer(duration) {
    if (duration >= oneDay.asMilliseconds()) {
        return moment_1.default.duration(duration).humanize();
    }
    else if (duration >= oneHour.asMilliseconds()) {
        return moment_1.default.utc(duration).format('HH:mm:ss');
    }
    else {
        return moment_1.default.utc(duration).format('mm:ss');
    }
}
exports.default = humanizeTimer;
//# sourceMappingURL=humanizeTimer.js.map